var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalhaDeHardware(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.069,
    height: 20.069,
    viewBox: "0 0 20.069 20.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_867",
    "data-name": "Caminho 867",
    d: "M160.773,183.539v16.608h4.46v3.462h2.23v-3.462h2.23v3.462h2.23v-3.462h2.23v3.462h2.23v-3.462h4.46V183.539Zm15.588,11.081-2.412,2.412-3.141-3.141-3.141,3.141-2.412-2.412,3.141-3.141-3.141-3.141,2.412-2.412,3.141,3.141,3.141-3.141,2.412,2.412-3.141,3.141Z",
    transform: "translate(-160.773 -183.539)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalhaDeHardware);
export default __webpack_public_path__ + "static/media/falha-de-hardware.8218635348c4f0e15e0a6c2fca18eeda.svg";
export { ForwardRef as ReactComponent };